<template>
  <div>
    <v-container fluid pa-0 grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h2 class="headline">Configuration</h2>
            </v-card-title>
            <v-card-text>
              <v-layout wrap row class="pb-3">
                <v-flex xs12>
                  <v-switch
                    :color="appButtonColor"
                    v-model="config.maintenance"
                    @change="updateConfig({maintenance: true, event: $event})"
                    :label="`Maintenance ${config.maintenance ? 'On' : 'Off'}`"
                  ></v-switch>
                </v-flex>
                <v-flex xs12>
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        label="Maintenance Message"
                        :color="appButtonColor"
                        hide-details
                        v-model="config.message"
                        @keyup.enter="updateConfig()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-btn @click="updateConfig()">Update</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <div class="doc-header mb-3">Active Document Types</div>
                      <div class="doc-type" v-for="(value, key, ind) in activeDocuments" :key="ind">
                        <div class="doc-title">{{ key }}: </div>
                        <draggable class="doc-group" :list="value" :group="{ name: key, pull: false, put: ['container'] }" @change="typeUpdated($event, key, ind)">
                          <div class="doc-item" v-for="(item, i) in value" :key="item.id">
                            {{ item.name }}
                            <v-icon
                              @click="typeUpdated(item, key)"
                              color="red"
                              small
                            >cancel</v-icon>
                          </div>
                        </draggable>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="doc-header mb-3">Document Type Options</div>
                      <draggable :move="checkDoc" class="doc-group" :list="allDocTypes" :group="{ name: 'container', pull: 'clone' }">
                        <div class="doc-item" v-for="(item,i) in allDocTypes" :key="item.id">
                          {{ item.name }}
                        </div>
                      </draggable>
                    </v-flex>
                    <!-- <v-flex xs12>
                      <v-btn class="ma-0 mt-3" @click="updateConfig({types: true})">Update</v-btn>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState, mapGetters } from "vuex";
import draggable from 'vuedraggable'
export default {
  name: "Config",
  data() {
    return {
      maintenance: "",
      hover: false,
      hoverId: "",
      docTypes: [],
      allTypes: [
        {"filterType":1,"id":"1250","name":"Loan Statements"},
        {"filterType":1,"id":"5070","name":"Wealth Statements"},
        {"filterType":1,"id":"3271","name":"Statement"},
        {"filterType":1,"id":"3397","name":"1099R"},
        {"filterType":1,"id":"5525","name":"403(b) Notice of Availability"},
        {"filterType":1,"id":"5520","name":"Participant Fee/Investment Disclosure"},
        {"filterType":1,"id":"5527","name":"Automatic Contribution Arrangement (ACA)"},
        {"filterType":1,"id":"5524","name":"Black Out Notice"},
        {"filterType":1,"id":"3856","name":"Confirms"},
        {"filterType":1,"id":"5526","name":"Eligible Automatic Contribution Arrangement (EACA)"},
        {"filterType":1,"id":"3187","name":"Invoices"},
        {"filterType":1,"id":"5541","name":"Notice of Discretionary Match"},
        {"filterType":1,"id":"5539","name":"IRS Tax Notice"},
        {"filterType":1,"id":"5544","name":"Additional documents"},
        {"filterType":1,"id":"5528","name":"Qualified Default Investment Alternative (QDIA)"},
        {"filterType":1,"id":"5540","name":"QDIA Fund Fact Sheets"},
        {"filterType":1,"id":"5529","name":"Qualified Joint and Survivor Annuity Explanation"},
        {"filterType":1,"id":"5523","name":"Notice of Fund Change"},
        {"filterType":1,"id":"5530","name":"Qualified Pre-Retirement Survivor Annuity Explanation"},
        {"filterType":1,"id":"5538","name":"Safe Harbor Notice"},
        {"filterType":1,"id":"5531","name":"Safe Harbor Notice - Qualified Automatic Contribution Arrangement (QACA)"},
        {"filterType":1,"id":"5521","name":"Summary Annual Report (SAR)"},
        {"filterType":1,"id":"5522","name":"Summary of Material Modifications (SMM)"},
        {"filterType":1,"id":"5537","name":"Summary Plan Description (SPD)"},
        {"filterType":1,"id":"5543","name":"Summary Plan Description Appendix"},
        {"filterType":1,"id":"29","name":"Check Image"},
        {"filterType":1,"id":"2626","name":"Deposit Statements"},
        {"filterType":1,"id":"5552","name":"Quarterly Performance Report"},
        {"filterType":2,"id":"1","name":"Plan Documents and Notices"}]
    };
  },
  computed: {
    ...mapState("user", [
      "user",
      "state",
      "confirmed",
      "mersBranded",
      "config",
      "activeDocuments",
      "containers"
    ]),
    ...mapState("accounts", ["accounts"]),
    ...mapGetters("user", [
      "isAuthenticated",
      "userGroup",
      "adminOrSuper",
      "poolId"
    ]),
    allDocTypes() {
      if (!this.config) return []
      return this.allTypes
      // return this.allTypes.filter(type => {
      //   return !this.config.docTypes.some(doc => type.name === doc.name)
      // })
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
  },
  components: {
    draggable
  },
  async created() {
    await this.copyConfig()
  },
  methods: {
    removeHover(event) {
      this.hover = false
      return true
    },
    hoverDoc(id) {
      if (this.hover && id === this.hoverId) return true
      else return false
    },
    setHover(val, id) {
      if (val === "on") {
        this.hover = true
        this.hoverId = id
      }
      else {
        this.hover = false
        this.hoverId = ""
      }
    },
    checkDoc({ draggedContext, relatedContext } = event) {
      let { element } = draggedContext
      let { list } = relatedContext
      if (list.length === this.allDocTypes.length) return true
      else if (list.some(item => item.name === element.name)) return false
    },
    async copyConfig(maintenance) {
      if (!maintenance) maintenance = await this.$store.dispatch("user/checkConfig");
      // if (maintenance.docTypes.length) {
      //   if (maintenance.docTypes[0] !== '') {
      //     this.docTypes = maintenance.docTypes.map(item => {
      //       return {
      //         type: item
      //       }
      //     })
      //   }
      // }
      this.maintenance = JSON.parse(JSON.stringify(maintenance));
      // await this.setupActiveDocuments()
    },
    async setupActiveDocuments() {
      let docTypes = {}
      this.containers.forEach(item => docTypes[item.label] = this.activeDocuments.filter(doc => {
        return doc.container === item.name
      }))
      console.log(docTypes)
    },
    async addType() {
      this.docTypes.push({type: ''})
      await this.$nextTick()
      this.$refs.field[this.docTypes.length - 1].focus()
    },
    typeClicked(val, event, ind) {
      // if (val === 1) {
      //   this.config.docTypes.splice(ind, 1)
      // }
      // else if (val === 2) {
      //   this.config.docTypes.push(event)
      // }
      // this.updateConfig({types: true})
    },
    async typeUpdated(val, list, ind) {
      if (val.added) {
        let el = JSON.parse(JSON.stringify(val.added.element))
        el.container = this.containers[ind].name
        el.lob = this.mersBranded ? "MERS" : "Alerus"
        el.documentId = el.id
        el.list = list
        el.order = 1
        let newDoc = await this.$store.dispatch("user/createActiveDocument", el)
        if (newDoc && this.activeDocuments[list].length > 1) {
          let res = await Promise.all(this.activeDocuments[list].map((item,i) => {
            return this.$store.dispatch("user/updateActiveDocument", {
              id: item.id,
              order: i + 1
            })
          }))
          if (res.every(Boolean)) this.displayNotification("success", "Documents")
          else this.displayNotification("error", "documents")
        }
        else if (newDoc) this.displayNotification("success", "Documents")
        else this.displayNotification("error", "documents")
      }
      else if (val.moved) {

        let res = await Promise.all(this.activeDocuments[list].map((item,i) => {
          return this.$store.dispatch("user/updateActiveDocument", {
            id: item.id,
            order: i + 1
          })
        }))
        if (res.every(Boolean)) this.displayNotification("success", "Documents")
        else this.displayNotification("error", "documents")
      }
      else {
       let doc = await this.$store.dispatch("user/deleteActiveDocument", val.id)
       if (doc) {
         this.$store.commit("user/removeActiveDocument", {
           list,
           id: val.id
         })
         this.displayNotification("success", "Documents")
       }
       else this.displayNotification("error", "documents")
      }
      // this.updateConfig({types: true})
      // let { added, removed } = val
      // if (list === 1) {

      // }
      // else if (list === 2) {
      //   if (removed) {

      //   }
      // }
    },
    async updateConfig({maintenance = false, event, types = false} = {}) {
      let config;
      if (maintenance) {
        config = {
          maintenance: event
        }
      } 
      else if (types) {
        config = {
          docTypes: this.config.docTypes
        }
      }
      else {
        if (this.maintenance.message === this.config.message) return;
        config = {
          message: this.config.message
        }
      }
      let { res, newConfig } = await this.$store.dispatch("user/updateConfig", config);
      if (res) {
        this.copyConfig(newConfig)
        this.displayNotification("success", "Config")
      }
      else this.displayNotification("error", "config")
      // if (maintenance) {
      //   if (newConfig.maintenance === this.config.maintenance) {
      //     this.displayNotification("success", "Maintenance");
      //     this.maintenance = newConfig;
      //   } else {
      //     this.displayNotification("error", "Maintenance");
      //     this.$store.commit("user/setConfig", this.maintenance);
      //   }
      // } else {
      //   if (newConfig.message === this.config.message) {
      //     this.displayNotification("success", "Message");
      //     this.maintenance = newConfig;
      //   } else {
      //     this.displayNotification("error", "Message");
      //     this.$store.commit("user/setConfig", this.maintenance);
      //   }
      // }
    },
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification} updated`);
      } else if (type === "number") {
        this.$snotify["error"](`${notification}`, "", {
          timeout: 0
        });
      } else {
        this.$snotify[type](`Error updating ${notification}`, "", {
          timeout: 0
        });
      }
    }
  }
};
</script>

<style lang="scss">
  .doc-header {
    font-size: 1.5rem;
    margin-top: 2rem;
    display: inline-block;
  }
  .doc-item {
    flex: 0 1 auto;
    cursor: grab;
    padding: 0.5rem;
    position: relative;
    border: 1px solid #0B2A4A;
    background: #f9f9f9;
    margin: 0.25rem;
    &:hover {
      // text-decoration: line-through;
    }
    .v-icon {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      background: #fff;
    }
  }
  .doc-group {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
  }
  .doc-title {
    font-size: 1.3rem;
  }
  .doc-type {
  }
</style>
